'use client';

import { TypeBlockGradientCta } from '@fm-nx/contentful-types';

export type BlockGradientCtaProps = {
    blockGradientCta: TypeBlockGradientCta<'WITHOUT_UNRESOLVABLE_LINKS'>;
    mode?: 'dark' | 'light';
};

const gradientMap: Record<string, { light: string; dark: string }> = {
    'Green/Blue': { light: 'from-green-600 to-blue-600', dark: 'from-green-400 to-blue-400' },
    'Blue/Purple': { light: 'from-blue-600 to-purple-600', dark: 'from-blue-400 to-purple-400' },
    'Purple/Pink': { light: 'from-purple-600 to-red-600', dark: 'from-purple-400 to-red-400' },
    'Red/Yellow': { light: 'from-red-700 to-yellow-600', dark: 'from-red-400 to-yellow-300' },
    'Yellow/Teal': { light: 'from-yellow-500 to-teal-700', dark: 'from-yellow-300 to-teal-500' },
};

export function BlockGradientCta(props: BlockGradientCtaProps) {
    const { blockGradientCta } = props;

    if (!blockGradientCta?.fields) return null;

    const { text, gradient } = blockGradientCta.fields;

    const gradientKey = gradient && gradientMap[gradient] ? gradient : 'Green/Blue';

    const gradientColors = gradientMap[gradientKey];

    const gradientClass = props.mode === 'dark' ? gradientColors.dark : gradientColors.light;

    return (
        <section className="w-full py-16 px-6 md:grid md:grid-cols-14">
            <div className="md:col-span-12 md:col-start-2">
                <p
                    className={`h1 font-bold leading-tight bg-gradient-to-r bg-clip-text text-transparent inline-block ${gradientClass}`}
                >
                    {text}
                </p>
            </div>
        </section>
    );
}

export default BlockGradientCta;
